import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnInit,
    ViewChild
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { AuthService } from '@craig/core';
import { ResponseFeedbackOption, ResponseFeedbackPayload } from '../../../interfaces/response-feedback.interface';
import { FEEDBACK_OPTIONS_CONFIG } from '../../../config/feedback-options.config';
import { ChatService } from '../../../services/chat/chat.service';

@Component({
    selector: 'craig-response-feedback',
    templateUrl: './response-feedback.component.html',
    styleUrl: './response-feedback.component.less',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResponseFeedbackComponent implements OnInit {
    @Input() requestId: string = '';
    @ViewChild('feedbackContainer') feedbackContainer!: ElementRef;
    feedbackOptions: ResponseFeedbackOption[] = FEEDBACK_OPTIONS_CONFIG();
    selectedFeedbackOption: ResponseFeedbackOption | undefined = undefined;
    feedbackForm!: FormGroup;

    constructor(
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly fb: FormBuilder,
        private readonly chatService: ChatService,
        private readonly authService: AuthService
    ) {}

    ngOnInit(): void {
        this.initForm();
    }

    onFeedbackOptionClick(option: ResponseFeedbackOption): void {
        this.selectedFeedbackOption = option;
        this.feedbackForm.reset({ reasons: [], comment: '' });

        this.changeDetectorRef.detectChanges();
        this.feedbackContainer.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
        });
    }

    submitResponseFeedback(): void {
        const responseFeedbackPayload: ResponseFeedbackPayload = {
            request_id: this.requestId,
            email: this.authService.getUserEmail(),
            ratings: {
                answer_correct: this.selectedFeedbackOption!.value,
                reasons: this.feedbackForm.value.reasons,
                comments: this.feedbackForm.value.comment
            }
        };

        this.chatService.sendResponseFeedback(responseFeedbackPayload).subscribe();
        this.resetResponseFeedback();
    }

    onToggleFeedbackReason(clickedReason: string, isChecked: boolean): void {
        const reasons: string[] = this.feedbackForm.controls['reasons'].value;

        if (isChecked) {
            this.feedbackForm.controls['reasons'].setValue([...reasons, clickedReason]);
        } else {
            this.feedbackForm.controls['reasons'].setValue(
                reasons.filter((reason: string) => reason !== clickedReason)
            );
        }
    }

    onCommentChange(event: Event): void {
        if (this.feedbackForm) {
            const commentValue: string = (event.target as HTMLInputElement).value;

            this.feedbackForm.controls['comment'].setValue(commentValue);
        }
    }

    private initForm(): void {
        this.feedbackForm = this.fb.group({
            reasons: new FormControl([]),
            comment: new FormControl('')
        });
    }

    private resetResponseFeedback(): void {
        this.selectedFeedbackOption = undefined;
        this.feedbackForm.reset();
    }
}
